import currency from 'currency.js';

export const formatUSD = (value) => currency(value).format();
